// schema
import * as ISchema from "#webapp/src/__schema__";

// libraries
import * as React from "react";
import { createRefetchContainer } from "react-relay";

// org-settings imports
import { orgSettingsFragments, query } from "./OrgSettings.gql";
import { styles } from "./OrgSettings.styles";
import { IContainer, IProps, IState } from "./OrgSettingsTypes";
// internals
import { ZoomSettings } from "#webapp/src/components/zoom-settings";
// other imports
import { AvatarRow } from "#webapp/src/components/avatar-row";
// state

// util
import { logger } from "#webapp/src/util/logger.util";
import { getDomainOffEmail } from "@clockwise/client-commons/src/util/email";
// import { track, TrackingEvents } from 'src/util/analytics.util';

// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import { OrgTimeZone } from "./OrgTimeZone";

///////////////
// Component //
///////////////
class OrgSettingsCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private getCurrentOrgPersons = (org: ISchema.IOrg) => {
    if (org.currentOrgPersons.__typename === "GraphEntityError") {
      logger.error("failed to render curent users from getCurrentOrgPersons");
      return [];
    }
    return org.currentOrgPersons.list;
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const { user, org, classes } = this.props;
    const orgDomain = getDomainOffEmail(org.primaryOrgCalendar);

    const MAX_RENDERED_AVATARS = 6;
    let teammates: ISchema.IOrgPerson[] = [];
    let extraTeammatesCount = 0;

    const currentOrgPersons = this.getCurrentOrgPersons(org);

    teammates = [...currentOrgPersons].slice(0, MAX_RENDERED_AVATARS);

    extraTeammatesCount =
      currentOrgPersons.length > MAX_RENDERED_AVATARS
        ? currentOrgPersons.length - MAX_RENDERED_AVATARS
        : 0;

    return (
      <div className={classes.container}>
        <div className={classes.row}>
          <AvatarRow
            orgPersons={teammates}
            maxAvatarCount={MAX_RENDERED_AVATARS}
            size="large"
            extraOverflowCount={extraTeammatesCount}
            showTooltip={true}
          />
          <div className={classes.intro}>
            These settings apply to all {currentOrgPersons.length}{" "}
            {currentOrgPersons.length === 1 ? "person" : "people"} in the {orgDomain} organization
          </div>
        </div>
        <OrgTimeZone />
        <ZoomSettings user={user} org={org} />
      </div>
    );
  }
}

/////////////////
// With Styles //
/////////////////
export const OrgSettingsStyled = withStyles(styles)(OrgSettingsCmpt);

export const OrgSettings = createRefetchContainer<IContainer>(
  OrgSettingsStyled,
  orgSettingsFragments,
  query,
);
